'use strict';

const e = React.createElement;

class LikeButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = { liked: false };
    }

    render() {
        if (this.state.liked) {
            return 'You liked comment number ' + this.props.commentID;
        }

        return e(
            'button',
            { onClick: () => this.setState({ liked: true }) },
            'Like'
        );
    }
}

jQuery(document).ready(() => {
    let $doc = jQuery( document );
    let search = jQuery('.faq-search-input.form-control');
    if(search.length > 0) {
        console.log('found');
        search.on('keyup', () => {
            let value = search.val();

            let reg = new RegExp(value, 'i');

            jQuery('.pp-accordion .pp-accordion-item').each((index, item) => {
                let $element = jQuery(item);
                if(value === null || value.trim().length === 0) {
                    $element.removeClass('hide');
                }
                else {
                    let text = $element.text();
                    if (reg.test(text)) {
                        $element.removeClass('hide');
                    }
                    else{
                        $element.addClass('hide');
                    }


                }
            })
        })
    }

    if(window.landwey_global) {
        let image = '<img src="'+window.landwey_global.profile_image+'" class="user-profile-image" style="display: none"/>';
        let name = '<span class="user-profile-name"><span>' + window.landwey_global.profile_name+'</span>' + image + ' '+"<i class='fa fa-cog'></i>"+'</span>';
        jQuery('.user-log-out>a').html(name);
        jQuery('.user-log-out').addClass('image-added');
    }
    jQuery('.user-log-ing').append("<i class='fa fa-user'></i>");
    jQuery('#home-testimonial .esg-filters.esg-singlefilters.esg-navbutton-solo-left .esg-navigationbutton').append("<img src='/wp-content/themes/landwey/images/next-left.png'/>");
    jQuery('#home-testimonial .esg-filters.esg-singlefilters.esg-navbutton-solo-right .esg-navigationbutton').append("<img src='/wp-content/themes/landwey/images/next-right.png'/>");

    jQuery('.sxc-follow-button a[title=Facebook] img').attr('src', '/wp-content/themes/landwey/images/social-icons/facebook.svg');
    jQuery('.sxc-follow-button a[title=Twitter] img').attr('src', '/wp-content/themes/landwey/images/social-icons/twitter.svg');
    jQuery('.sxc-follow-button a[title=Instagram] img').attr('src', '/wp-content/themes/landwey/images/social-icons/instagram.svg');
    jQuery('.sxc-follow-button a[title=YouTube] img').attr('src', '/wp-content/themes/landwey/images/social-icons/youtube.svg');


    setTimeout(function () {
        jQuery('.sxc-follow-buttons').addClass('force-show');
        jQuery('.fl-offcanvas-close .fas.fa-times').removeClass('fas').addClass('fa');
        let whatsAppContainer = jQuery('.wptwa-container');
        if(whatsAppContainer.length > 0) {
            //<span><i className='fa-phone-volume fa'></i></span>
            let content = "<div class='contact-telephone-direct'><a href='tel:0700 0526 3939'><img src='/wp-content/themes/landwey/images/social-icons/phone.svg'/></a> </div> ";
            jQuery(content).insertBefore(whatsAppContainer);
        }
    }, 3000);

$doc.scroll(function() {
    if($doc.scrollTop() >= 50) {
        jQuery('body').addClass("fixed-header-offset");
    }
    else {
        jQuery('body').removeClass("fixed-header-offset");
    }
});
});

// Find all DOM containers, and render Like buttons into them.
// document.querySelectorAll('#like_button_container')
//     .forEach(domContainer => {
//         // Read the comment ID from a data-* attribute.
//         const commentID = parseInt(domContainer.dataset.commentid, 10);
//         ReactDOM.render(
//             e(LikeButton, { commentID: commentID }),
//             domContainer
//         );
//     });
